import React, { useEffect, useState } from 'react'
import { Dropdown, DropdownProps } from 'react-bootstrap'
import {
  BasicDropdownToggle,
  BasicDropdownMenu,
  BasicDropdownContent,
  BasicDropdownMenuItem,
  BasicDropdownIcon,
  BasicDropdownSectionContainer,
  BasicDropdownSectionTitle,
  BasicDropdownSectionDivider,
  BasicDropdownToggleText,
} from './BasicDropdown.styles'
import {
  BASIC_DROPDOWN_DROP,
  BASIC_DROPDOWN_ALIGN,
} from './BasicDropdown.constants'
import {
  BasicDropdownItem,
  BasicDropdownProps,
  BasicDropdownSection,
} from './BasicDropdown.types'

export const BasicDropdown = ({
  selectedItem,
  items,
  sections,
  onSelect,
  drop = BASIC_DROPDOWN_DROP.DOWN,
  align = BASIC_DROPDOWN_ALIGN.START,
  backgroundColor,
  borderColor,
  customToggle,
  disabled,
  onToggle,
  show,
  offset,
  size = 'small',
  isMenuFullWidth = false,
}: BasicDropdownProps): JSX.Element => {
  const [selected, setSelected] = useState<BasicDropdownItem>(selectedItem)

  useEffect(() => {
    setSelected(selectedItem)
  }, [selectedItem])

  const onSelectItem = (item: BasicDropdownItem) => {
    setSelected(item)
    onSelect(item)
  }

  return (
    <Dropdown
      drop={drop as unknown as DropdownProps['drop']}
      align={align as unknown as DropdownProps['align']}
      onToggle={onToggle}
      show={show}
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
      }}
    >
      {customToggle ? (
        customToggle
      ) : (
        <BasicDropdownToggle
          $backgroundColor={backgroundColor}
          $borderColor={borderColor}
          disabled={disabled}
          $size={size}
        >
          <BasicDropdownToggleText>{selected.name}</BasicDropdownToggleText>
          {!disabled && <BasicDropdownIcon />}
        </BasicDropdownToggle>
      )}
      <BasicDropdownMenu $offset={offset} $isFullWidth={isMenuFullWidth}>
        <BasicDropdownContent>
          {sections ? (
            <>
              {sections.map((section: BasicDropdownSection, index: number) => (
                <BasicDropdownSectionContainer key={section.title}>
                  {section.title && (
                    <BasicDropdownSectionTitle>
                      {section.title}
                    </BasicDropdownSectionTitle>
                  )}
                  {section.items.map((item: BasicDropdownItem) => {
                    const handleItemClick = () => {
                      const selectHandler = section.onSelect || onSelectItem
                      selectHandler(item)
                    }

                    return (
                      <BasicDropdownMenuItem
                        key={item.name}
                        onClick={handleItemClick}
                        eventKey={item.value}
                        $isBold={item.isBold}
                        $size={size}
                      >
                        {item.name}
                      </BasicDropdownMenuItem>
                    )
                  })}
                  {index < sections.length - 1 && (
                    <BasicDropdownSectionDivider />
                  )}
                </BasicDropdownSectionContainer>
              ))}
            </>
          ) : (
            <>
              {items.map((item: BasicDropdownItem) => {
                return (
                  <BasicDropdownMenuItem
                    key={item.name}
                    onClick={() => onSelectItem(item)}
                    eventKey={item.value}
                    $isBold={item.isBold}
                    $size={size}
                  >
                    {item.name}
                  </BasicDropdownMenuItem>
                )
              })}
            </>
          )}
        </BasicDropdownContent>
      </BasicDropdownMenu>
    </Dropdown>
  )
}
